import { FilterIcon, RotateCcw } from "lucide-react"
import "./index.css"
import { Button } from "react-bootstrap"

const FilterBtn = ({ onClick = () => { }, className = "", active = false, count = null, ...rest }) => (
    <button
        onClick={onClick}
        className={`rounded-2 position-relative filter-btn ${className} ${active ? "active" : ""}`}
        {...rest}
    >
        <FilterIcon size={14} className="me-2" />
        {/* btn-active --- Apply Filter Class */}
        Filter
        {active && (
            <span className="position-absolute top-0 start-100 translate-middle filter-count fw-semibold" style={{ fontSize: "10px" }}>
                {count}
            </span>
        )}
    </button>
)
const ResetBtn = ({ onClick = () => { }, className = "" }) => (
    <button
        onClick={onClick}
        className={`reset-btn ${className}`}
    >
        <RotateCcw size={16} />
    </button>
)
const IconBtn = ({ variant = "primary", onClick = () => { }, className = "", icon, size = 32, ...rest }) => (
    <Button
        onClick={onClick}
        variant={variant}
        className={`icon-btn ${className}`}
        style={{ width: `${size}px`, height: `${size}px` }}
        {...rest}
    >
        {icon}
    </Button>
)

export { FilterBtn, ResetBtn, IconBtn }